const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024; // 20 MB

const ALLOWED_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);

export type FileValidationError = "size" | "type";

export function validateContractFile(file: File): FileValidationError | null {
  if (file.size > MAX_FILE_SIZE_BYTES) return "size";
  if (!ALLOWED_MIME_TYPES.has(file.type)) return "type";
  return null;
}

// Uses FileReader to avoid the slow per-byte String.fromCharCode loop.
// Strips the "data:<mime>;base64," prefix so only the raw base64 is returned.
function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.slice(result.indexOf(",") + 1);
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export async function browserFileToProtoFile(file: File) {
  return {
    bytes: await fileToBase64(file),
    name: file.name.split(".")[0],
    format: file.name.split(".").pop() ?? "",
  };
}
